import { literal, union } from 'io-ts/Decoder';

export const Status = union(
	literal('unavailable'), // step cannot be interacted with yet (default-state or fallback state)
	literal('current'), // the active step the user should work on
	literal('processing'), // the commit command is in flight on Brain Engine side
	literal('completed'), // step is confirmed and read-only
	literal('failed'), // step failed
	literal('notRequired') // step does not apply to this job (e.g. alignment on single-level)
);
